import api from './api';
import store from '../Redux/store'; // Asegúrate de importar tu store de Redux
import ErrorService from './errorService';
import Cookies from 'universal-cookie';


export const userService = {
  register: async (userDTO) => {
    try {
      const response = await ErrorService.withTimeout(api.post('/User/register', userDTO));
      return response.data;
    } catch (error) {
      ErrorService.handleApiError('Error al registrar usuario:', error);
    }
  },

  login: async (email, password) => {
    try {
      const response = await ErrorService.withTimeout(api.post('/User/login', { email, password }));
      const cookies = new Cookies(null, { path: '/' })
      cookies.set('expirationTime', response.data.expirationTime, { path: '/' })
      cookies.set('identifier', response.data.identifier, { path: '/' })
      cookies.set('token', response.data.token, { path: '/' })
      cookies.set('userId', response.data.userId, { path: '/' })
      cookies.set('userName', response.data.userName, { path: '/' })
      return response.data;
    } catch (error) {
      ErrorService.handleApiError('Error al iniciar sesión:', error);
    }
  },

  logout: async () => {
    try {
      const response = await ErrorService.withTimeout(api.post('/User/logout'));

      const cookies = new Cookies()
      cookies.remove('expirationTime', { path: '/' })
      cookies.remove('identifier', { path: '/' })
      cookies.remove('token', { path: '/' })
      cookies.remove('userId', { path: '/' })
      cookies.remove('userName', { path: '/' })

      return response.data;
    } catch (error) {
      ErrorService.handleApiError('Error al cerrar sesión:', error);
    }
  },

  getAllUsers: async () => {
    try {
      const response = await ErrorService.withTimeout(api.get('/User'));
      return response.data;
    } catch (error) {
      ErrorService.handleApiError('Error al obtener usuarios:', error);
    }
  },

  updateUser: async (id, userUpdateDTO) => {
    try {
      //const identifier = getIdentifier(store.getState());
      const response = await ErrorService.withTimeout(api.put(`/User/${id}`, {
        ...userUpdateDTO,
        //updatedBy: identifier
      }));
      return response.data;
    } catch (error) {
      ErrorService.handleApiError(`Error al actualizar usuario con id ${id}:`, error);
    }
  },


  resetPassword: async (id, defaultPassword) => {
    try {
      const response = await ErrorService.withTimeout(api.post(`/User/${id}/reset-password`, { defaultPassword }));
      return response.data;
    } catch (error) {
      ErrorService.handleApiError(`Error al resetear contraseña para usuario con id ${id}:`, error);
    }
  },

  changePassword: async (currentPassword, newPassword) => {
    try {
      const response = await ErrorService.withTimeout(api.post('/User/change-password', { currentPassword, newPassword }));
      return response.data;
    } catch (error) {
      ErrorService.handleApiError('Error al cambiar la contraseña:', error);
    }
  },

  // Método para probar el endpoint protegido
  testProtectedEndpoint: async () => {
    try {
      const response = await ErrorService.withTimeout(api.get('/User/protected'));
      return response.data;
    } catch (error) {
      ErrorService.handleApiError('Error al acceder al endpoint protegido:', error);
    }
  }
};